import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartBars = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.7494 15.75V11.25M9 15.75V6.75M14.2506 15.75V2.25",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgChartBars);
export default ForwardRef;
